import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import I10n from "../features/i10n";
import Tooltip from "./documentation/tootip";
import InformationIcon from "../atoms/information-icon";

const Warning = styled.span`
  font-weight: bold;
  color: #626469;

  @media (max-width: 500px) {
    display: none;
  }
`;

const CountryIconWrapper = styled.div`
  color: #e47f00;
  font-weight: bold;
  margin-left: 5px;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
  transform: scale(0.8);
`;

const CountryHint = styled.div`
  color: #e47f00;
  padding: 10px;
  min-width: 200px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  margin-right: 5px;
`;

const GlobalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const CustomText = styled.div`
  word-wrap: break-word;
  white-space: pre-line;
  color: #0f0f0f;
`;

const HorizontalAlignContainer = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  margin-left: -8px;
`;

class CommercializationStatus extends Component {
  static propTypes = {
    availabilityStatus: PropTypes.bool,
    country: PropTypes.object,
  };

  render() {
    const { availabilityStatus } = this.props;

    if (availabilityStatus) {
      return null;
    } else {
      return (
        <GlobalWrapper>
          <Warning>{I10n.get("not_commercialized")}</Warning>
          <Tooltip
            data-clickable
            toggleElement={
              <CountryIconWrapper slot="trigger">
                <InformationIcon size="small"></InformationIcon>
              </CountryIconWrapper>
            }
            containerElement={
              <CountryHint>
                <HorizontalAlignContainer>
                  <CountryIconWrapper slot="trigger">
                    <InformationIcon size="small"></InformationIcon>
                  </CountryIconWrapper>
                  <span>
                    {I10n.getAndReplace(
                      "screen.start_configuration_screen.country_hint_issue"
                    )}
                  </span>
                </HorizontalAlignContainer>
                <CustomText>
                  {I10n.getOrDefault(
                    "screen.start_configuration_screen.country_hint_warning",
                    this.props.country || "WW"
                  )}
                </CustomText>
              </CountryHint>
            }
            allowTop={true}
          ></Tooltip>
        </GlobalWrapper>
      );
    }
  }
}

export default CommercializationStatus;
